<template>
   <b-toast id="toast-realtime" :visible="hasNotifications" no-auto-hide toaster="b-toaster-top-center toast-selfie">
    <div class="d-flex text-left mb-3">
      <div class="mr-3">
        <Icon name="imagePlus" width="32" class="icon-circle"/>
      </div>
      <div>
        <div class="font-weight-semi-bold">{{$t('realtime_notification.title')}}</div>
        <div class="text-left">{{ notificationMessage }}</div>
      </div>
      <div class="ml-auto">
        <b-link href="#" @click.prevent="handleClose">
          <Icon name="close" width="20"/>
        </b-link>
      </div>
    </div>
     <div class="d-flex justify-content-end">
       <b-link href="#" class="text-decoration-none font-weight-semi-bold" @click.prevent="handleReload">
         <span v-if="isLoading">{{$t('realtime_notification.loading')}}</span>
         <span v-else>{{$t('realtime_notification.reload')}}</span>
         <Icon name="reloadCw" width="18" class="ml-2" :class="{ 'spinning': isLoading }"/>
       </b-link>
     </div>
  </b-toast>
</template>

<script>
import eventBusConstants from '@/domain/core/constants/eventBus'

export default {
  name: 'RealtimeNotificationPopup',
  
  data() {
    return {
      pendingNotifications: [],
      isLoading: false
    }
  },
  
  computed: {
    hasNotifications() {
      return this.pendingNotifications.length > 0
    },
    
    notificationMessage() {
      if (this.pendingNotifications.length === 0) return ''
      return this.$t('realtime_notification.message')
    }
  },
  
  methods: {
    async handleReload() {
      if (this.isLoading) return
      
      this.isLoading = true
      
      try {
        // Execute all pending refresh functions in sequence
        for (const notification of this.pendingNotifications) {
          if (notification.onRefresh) {
            await notification.onRefresh()
          }
        }
        
        // If no custom refresh functions, fallback to page reload
        if (this.pendingNotifications.length > 0 && !this.pendingNotifications.some(n => n.onRefresh)) {
          window.location.reload()
        }
        
        // Close popup after successful refresh
        this.handleClose()
      } catch (error) {
        console.error('Error during refresh:', error)
        // Close popup even on error
        this.handleClose()
      } finally {
        this.isLoading = false
      }
    },
    
    handleClose() {
      this.pendingNotifications = []
    },
    
    handleShowPopup(payload) {
      // Check if we already have a notification for this gallery
      const existingIndex = this.pendingNotifications.findIndex(n => n.galleryId === payload.galleryId)
      
      if (existingIndex !== -1) {
        // Update existing notification with new data
        this.pendingNotifications[existingIndex] = payload
      } else {
        // Add new notification
        this.pendingNotifications.push(payload)
      }
    }
  },
  
  mounted() {
    // Listen for show_popup events
    this.registerEvent(eventBusConstants.realtimeNotifications.show_popup, this.handleShowPopup)
  },
  
  beforeDestroy() {
    // Unregister event listener
    this.unregisterEvent(eventBusConstants.realtimeNotifications.show_popup, this.handleShowPopup)
  }
}
</script>
<style scoped>
.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
